import api from './api';

export const geographicCoordinatesService = {

  getCoordinates: async (token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get('/geographic_coordinates/select', { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar coordenadas geográficas:', error);
      throw error;
    }
  },

  insertCoordinate: async (data, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post('/geographic_coordinates/insert', data, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao inserir coordenada geográfica:', error);
      throw error;
    }
  },

  updateCoordinate: async (id, data, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.put(`/geographic_coordinates/update/${id}/`, data, { headers });
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao atualizar coordenada geográfica:', error);
      throw error;
    }
  },

  deleteCoordinate: async (id, token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await api.delete(`/geographic_coordinates/${id}/delete`, { headers });
      return true;
    } catch (error) {
      console.error('❌ Erro ao deletar coordenada geográfica:', error);
      throw error;
    }
  },

  getCoordinatesByDescricao: async (descricao, token) => {
  try {
    const headers = { Authorization: `Bearer ${token}` };
    const response = await api.get(`/geographic_coordinates/select_by_descricao/${descricao}`, { headers });
    return response.data;
  } catch (error) {
    console.error('❌ Erro ao buscar coordenadas por descrição:', error);
    throw error;
  }
},


};
